import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
export function AboutCaro() {
  const blocks = [{
    heading: 'Mein Look & meine Maße',
    text: 'Ich bin 174 cm groß und wiege 62 kg. Meine Figur ist feminin und harmonisch proportioniert – mit natürlichen Kurven, die meinen Körper weich und gleichzeitig präsent wirken lassen. Meine BH-Größe ist 75C, ich trage Kleidergröße 36 (S) und Schuhgröße 40/41. Meine langen blonden Haare sind eines meiner Markenzeichen. Dazu kommen meine grünen Augen, die oft als besonders intensiv beschrieben werden.',
    image: 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-1.jpg',
    alt: 'Caro Loesel - Mein Look',
    reverse: false
  }, {
    heading: 'Meine Tattoos',
    text: 'Ich habe viele Tattoos und mehrere Piercings, vor allem an den Ohren. Meine Tattoos sind ein Teil meiner Persönlichkeit – sie unterstreichen meinen individuellen Stil und verleihen meinem Look eine starke, moderne Note. Ich stehe für natürliche Weiblichkeit, echte Ausstrahlung und eine selbstbewusste Präsenz vor der Kamera.',
    image: 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-2.jpg',
    alt: 'Caro Loesel - Meine Tattoos',
    reverse: true
  }, {
    heading: 'Meine Plattformen',
    text: 'Ich veröffentliche regelmäßig exklusive Inhalte auf verschiedenen Plattformen. Dort teile ich Fotos, Videos und persönliche Einblicke in meine Welt. Auf OnlyFans findest du meine privateste Seite mit regelmäßigen Updates. Auf Maloum erwarten dich hochwertige Fotosets und professionelle Produktionen. Über meinen WhatsApp-Chat kannst du mir persönlich schreiben und direkten Kontakt zu mir aufnehmen. Jede Plattform zeigt eine andere Facette von mir – ästhetisch, sinnlich, selbstbewusst.',
    image: 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-3.jpg',
    alt: 'Caro Loesel - Meine Plattformen',
    reverse: false
  }, {
    heading: 'Buch mich als Model',
    text: 'Neben meinen Online-Plattformen bin ich auch als professionelles Model buchbar. Ob für Fotoshootings, Werbekampagnen, Content-Produktionen oder Messeauftritte – ich bringe Erfahrung, Präsenz und eine starke Ausstrahlung mit. Ich arbeite zuverlässig, professionell und mit einem klaren Gespür für Bildwirkung.',
    image: 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-4.jpg',
    alt: 'Caro Loesel - Booking',
    reverse: true,
    link: {
      url: 'https://www.model-kartei.de/sedcards/model/674011/caro-loesel/',
      label: 'Zur Sedcard auf Model-Kartei'
    }
  }, {
    heading: 'Werde Teil meiner Welt',
    text: 'Wenn du meine exklusive Seite kennenlernen möchtest oder mit mir zusammenarbeiten willst – hier bist du richtig. Ich bin Caro Loesel. Blond. Tätowiert. Kurvig. Und absolut echt.',
    image: 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-5.jpg',
    alt: 'Caro Loesel - Werde Teil meiner Welt',
    reverse: false
  }, {
    heading: 'Meine Leidenschaft',
    text: 'Das Modeln ist für mich mehr als nur ein Job – es ist meine Leidenschaft. Seit 2020 stehe ich vor der Kamera und liebe es, mich immer wieder neu zu erfinden. Jedes Shooting ist eine neue Möglichkeit, Facetten meiner Persönlichkeit zu zeigen und kreative Visionen zum Leben zu erwecken.',
    image: 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-6.jpg',
    alt: 'Caro Loesel - Leidenschaft',
    reverse: true
  }, {
    heading: 'Mein Lifestyle',
    text: 'Ich liebe das Leben und genieße jeden Moment. Ob auf Reisen, beim Sport oder einfach in der Natur – ich tanke Energie, wo ich nur kann. Ein gesunder Lifestyle und eine positive Einstellung sind mir wichtig, um mich in meinem Körper wohlzufühlen und diese Energie auch nach außen zu strahlen.',
    image: 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-7.jpg',
    alt: 'Caro Loesel - Lifestyle',
    reverse: false
  }, {
    heading: 'Zukunftsvisionen',
    text: 'Ich habe noch viel vor und freue mich auf alles, was kommt. Mein Ziel ist es, mich stetig weiterzuentwickeln, neue spannende Projekte umzusetzen und meine Community auf diesem Weg mitzunehmen. Bleib dran, es wird aufregend!',
    image: 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-9.jpg',
    alt: 'Caro Loesel - Zukunft',
    reverse: true
  }];
  return <section className="py-20 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-8">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="text-center mb-16 md:mb-24" data-id="element-9">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#1A1A1A] mb-4" data-id="element-10">
          Über mich
        </h2>
        <div className="w-16 h-1 bg-hotpink mx-auto rounded-full" data-id="element-11" />
      </motion.div>

      <div className="space-y-20 md:space-y-32" data-id="element-12">
        {blocks.map((block, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center`} data-id="element-13">
            {/* Image Column */}
            <motion.div initial={{
          clipPath: 'inset(10% 10% 10% 10%)'
        }} whileInView={{
          clipPath: 'inset(0% 0% 0% 0%)'
        }} viewport={{
          once: true,
          margin: '-10%'
        }} transition={{
          duration: 1.2,
          ease: [0.22, 1, 0.36, 1]
        }} className={`relative group ${block.reverse ? 'md:order-last' : 'md:order-first'} order-first`} data-id="element-14">
              <div className="relative rounded-xl overflow-hidden aspect-[4/5] border border-[#1A1A1A]/5 transition-all duration-500 group-hover:border-hotpink/50 group-hover:shadow-xl group-hover:shadow-hotpink/10" data-id="element-15">
                <img src={block.image} alt={block.alt} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-16" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-17" />
              </div>
            </motion.div>

            {/* Text Column */}
            <motion.div initial={{
          opacity: 0,
          x: block.reverse ? 30 : -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className={`${block.reverse ? 'md:order-first' : 'md:order-last'} order-last text-left pl-6 border-l-4 border-hotpink`} data-id="element-18">
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-[#1A1A1A] mb-4" data-id="element-19">
                {block.heading}
              </h3>
              <p className="text-text-secondary text-base md:text-lg leading-relaxed font-light font-sans mb-6" data-id="element-20">
                {block.text}
              </p>

              {block.link && <a href={block.link.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-hotpink font-semibold hover:text-hotpink/80 transition-colors group" data-id="element-21">
                  {block.link.label}
                  <ExternalLink className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-22" />
                </a>}
            </motion.div>
          </div>)}
      </div>
    </section>;
}